import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-id-entity',
  standalone: false,
  templateUrl: './input-id-entity.component.html',
  styleUrl: './input-id-entity.component.scss'
})
export class InputIdEntityComponent {

  id: number | null = null;
  dv: number | null = null;

  @Input() icon: string | null = null;
  @Input() placeholder: string | null = null;


  @Output() valueChange = new EventEmitter<String>();


  constructor() { }

  emitId({ id, dv }: { id: number | null; dv: number | null }) {
    this.id = id;
    this.dv = dv;

    let fullId = id + '';
    if (dv && dv !== null) {
      fullId += '-' + dv;
    }
    this.valueChange.emit(fullId ?? undefined);
  }

}
